module.exports = __webpack_public_path__ + "static/media/1O2A0783.07d540e0.jpg";